import { render } from "./DialogConfirmMenu.vue?vue&type=template&id=3dea6a7a"
import script from "./DialogConfirmMenu.vue?vue&type=script&lang=js"
export * from "./DialogConfirmMenu.vue?vue&type=script&lang=js"
script.render = render

export default script